import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { sendMessageAsync } from "./actions";
import { MessageState } from "./slice";

type ActionReducerMapBuilderWithMessageState =
  ActionReducerMapBuilder<MessageState>;

export const sendMessageReducer = (
  builder: ActionReducerMapBuilderWithMessageState
) => {
  builder.addCase(sendMessageAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(sendMessageAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(sendMessageAsync.rejected, (state) => {
    state.isLoading = false;
  });
};
